module.exports = __webpack_public_path__ + "img/unity.85add949.png";